module.exports = __webpack_public_path__ + "static/media/tit1.6e27b4df.png";